class ResourceManager {

    private static culture: string = "";

    public static getString(translate: string): string {

        return ResourceManager.getTranslation(translate);
    }

    public static setCulture(culture: string) {

        ResourceManager.culture = culture;
    }

    public static getTranslation(source: string) {
        
        var translatedValue = InovxLoader.t("viewer:" + source);

        if (translatedValue && translatedValue !== "viewer:" + source)
            return translatedValue;

        return source;
    }
}

export default ResourceManager;